export const SidebarData = [
  {
    title: "Releasenotes",
    icon: "bi bi-megaphone",
    link: "/release-notes",
    roles: ["eigenaar"]
  },
  {
    title: "Home",
    icon: "bi bi-house",
    link: "/home",
    roles: ["super_admin", "locatie_admin", "docent", "leerling", "ouder"]
  },
  {
    title: "Berichten",
    icon: "bi bi-chat-left-text",
    link: "/messages/inbox",
    roles: ["super_admin", "locatie_admin", "docent", "leerling", "ouder"]
  },
  {
    title: "Absenties",
    icon: "bi bi-clipboard-minus",
    link: "/absences",
    roles: ["super_admin", "locatie_admin", "docent", "leerling", "ouder"]
  },
  {
    title: "Gespreksnotities",
    icon: "bi bi-card-text",
    link: "/notes/allnotes",
    roles: ["super_admin", "locatie_admin", "docent"]
  },
  {
    title: "Toetsen",
    icon: "bi bi-clipboard-data",
    link: "/toetsen",
    roles: ["super_admin", "locatie_admin", "docent"]
  },
  {
    title: "Leerlingen",
    icon: "bi bi-backpack",
    link: "/allstudents",
    roles: ["super_admin", "locatie_admin"]
  },
  {
    title: "Ouders",
    icon: "bi bi-person",
    link: "/ouders",
    roles: ["super_admin", "locatie_admin"]
  },
  {
    title: "Docenten",
    icon: "bi bi-person-raised-hand",
    link: "/docenten",
    roles: ["super_admin", "locatie_admin"]
  },
  {
    title: "Groepen",
    icon: "bi bi-share",
    link: "/groups",
    roles: ["super_admin", "locatie_admin", "docent"]
  },
  {
    title: "Urenregistratie",
    icon: "bi bi-clock",
    link: "/userhours",
    roles: ["super_admin", "locatie_admin", "docent"]
  },
  {
    title: "Urenbeheer",
    icon: "bi bi-clock",
    link: "/adminhoursmanagement",
    roles: ["super_admin", "locatie_admin"]
  },
  {
    title: "Klantbeheer",
    icon: "bi bi-gear",
    link: "/klanten",
    roles: ["eigenaar"]
  },
  {
    title: "Locaties",
    icon: "bi bi-geo-alt",
    link: "/locaties",
    roles: ["super_admin"]
  },
  {
    title: "Gebruikers",
    icon: "bi bi-people",
    link: "/users",
    roles: ["eigenaar", "super_admin", "locatie_admin"]
  },
  {
    title: "Taken",
    icon: "bi bi-list-task",
    link: "/tasks",
    roles: ["super_admin", "locatie_admin"]
  },
  {
    title: "Privélessen",
    icon: "bi bi-person-video",
    link: "/private-lessons-home",
    roles: ["super_admin", "locatie_admin", "docent"],
    feature: "private_lessons"
  },
  {
    title: "Privélessen",
    icon: "bi bi-person-video",
    link: "/my-private-lessons",
    roles: ["ouder"],
    feature: "private_lessons"
  },
  {
    title: "Gespreksrondes",
    icon: "bi bi-calendar-event",
    link: "/meeting-rounds",
    roles: ["super_admin", "locatie_admin", "docent"]
  },
    {
    title: "Mededelingen",
    icon: "bi bi-megaphone",
    link: "/announcements",
    roles: ["super_admin", "locatie_admin"]
  },
  {
    title: "Mijn Gegevens",
    icon: "bi bi-person-gear",
    link: "/myprofile",
    roles: ["super_admin", "locatie_admin", "docent", "leerling", "ouder"]
  }
];
